import {GtmAbstractService} from "./gtm.abstract.service";
import {Injectable} from "@angular/core";
import {DataLayerModel} from "@merchant-webapp/components";

@Injectable({
	providedIn: "root"
})
export class GtmDummyService extends GtmAbstractService {
	pushEventToDataLayer(dataLayerModel: DataLayerModel): void {
	}

	pushMultipleEventsToDataLayer(dataLayerModels: DataLayerModel[]): void {
	}

	pushToDataLayer(event: object): void {
	}
}